export default __webpack_public_path__ + "static/media/map-order.1dd5bcb6.jpg";